import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useOutlet, useOutletContext, useParams } from "react-router-dom";
import FeesPayableEdit from "./FeesPayable";
import MuqeemTableEdit from "./MuqeemTable";
import { axios } from "../../../../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../../../../store/userSlice";
import LoadingWithLable from "../../../../../../../ReusableComponents/Loading/LoadingWithLable";

export default function EditFeesAndMuqeemContract() {
  const {contractDetails} = useOutletContext();
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [FEES_PAYABLE, SET_FEES_PAYABLE] = useState([]);
  const [MUQEEM_POINTS, SET_MUQEEM_POINTS] = useState([]);
  const { breadCrumbs } = useSelector((state) => state.user);
  const [allowEdit, setAllowEdit] = useState(false);
  const params = useParams();
  const currentContractId = params.contractId;

  const costDivide = (cost, value) => {
    if (cost == 0) return +cost;
    return Math.round(Math.ceil(+cost) / +value);
  };

  const quotationDetails = contractDetails?.quotation;
  const [costSheetDataLoading, setCostSheetDataLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [costSheetDefault, setCostSheetDefault] = useState({});
  const [selectDatas, setSelectDatas] = useState({});
  const [INITIAL_FEES, SET_INITIAL_FEES_PAYABLE] = useState([]);
  const [INITIAL_MUQEEM, SET_INITIAL_MUQEEM_POINTS] = useState([]);

  useEffect(() => {
    setSelectDatas(contractDetails);
    SET_INITIAL_FEES_PAYABLE(contractDetails.contract_fees_payables);
    SET_INITIAL_MUQEEM_POINTS(contractDetails.contract_muqeem_points);
    setCostSheetDataLoading(false);
  }, [contractDetails]);

  useEffect(() => {
    const isEditCostSheetInBreadcrumbs = breadCrumbs.some(
      (crumb) => crumb.label === "EDIT FEES PAYABLE & MUQEEM"
    );

    if (!isEditCostSheetInBreadcrumbs) {
      dispatch(
        setBreadCrumb([
          ...breadCrumbs,
          { label: "EDIT FEES PAYABLE & MUQEEM", link: `` },
        ])
      );
    }
  }, [location.pathname, selectDatas]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    const FINAL_FEE = generateFeeChanges(INITIAL_FEES, FEES_PAYABLE);
    const FINAL_MUQEEM = generateMuqeem(INITIAL_MUQEEM, MUQEEM_POINTS);
    const body = {
      contract_id: currentContractId,
      fees_payables: FINAL_FEE,
      muqeem_points: FINAL_MUQEEM,
    };

   
    axios
      .post(
        `/dashboard/contract-cost-sheet-module-muqeem-fees-payable-action`,
        body,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        dispatch(
          setAppError({
            msg: res?.data?.message || "UPDATED SUCCESSFULLY.",
            color: "success",
          })
        );
        navigate(`/dashboard/contract/${currentContractId}`, {
          state: { detailType: "COST SHEET" },
        });
      })
      .catch((err) => {
      
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        setSubmitLoading(false);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  return (
    <div className="!uppercase pt-5 pb-10">
      <h2 className="text-2xl text-center font-bold mb-10">
        Quotation Cost Sheet
      </h2>
      {!costSheetDataLoading ? (
        <>
          <div className="text-sm mx-auto max-w-sm">
            <div className="text-left">
              <p>
                <b> Quotation No.</b>: {quotationDetails?.quotation_number}
              </p>
              <p>
                <b>Quotation Name</b> : {quotationDetails?.name}
              </p>
              <p>
                <b>Quotation Type</b> : {contractDetails?.contract?.quotation_type?.name}
              </p>
              <p>
                <b>Client Name</b> : {contractDetails?.contract?.client?.name}
              </p>
              <p
                className={`mb-1 ${
                  contractDetails?.contract?.client?.client_specific?.length < 20
                    ? "flex"
                    : "block"
                }`}
              >
                <b>Client Specific </b> :
                {contractDetails?.contract?.client?.client_specific}
              </p>
            </div>
          </div>

          <div className="flex flex-col w-full gap-1 my-12 overflow-x-scroll px-8 pt-8">
            <form onSubmit={handleSubmit}>
              <FeesPayableEdit
                setAllowEdit={setAllowEdit}
                apiDatas={selectDatas}
                SET_FEES_PAYABLE={SET_FEES_PAYABLE}
              />
              <MuqeemTableEdit
                setAllowEdit={setAllowEdit}
                apiDatas={selectDatas}
                SET_MUQEEM_POINTS={SET_MUQEEM_POINTS}
              />

              <div className="absolute left-1/2 flex  w-full max-w-xs mt-10 gap-4 bottom-5">
                <button
                  className="ring-1 ring-black dark:ring-red uppercase w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
                  type="button"
                  disabled={submitLoading}
                  onClick={() => {
                    navigate(`/dashboard/contract/${currentContractId}`, {
                      state: { detailType: "COST SHEET" },
                    });
                  }}
                >
                  CANCEL
                </button>
                <button
                  className="bg-red rounded-md  text-white  p-2 px-10 cursor-pointer text-sm disabled:bg-rose-400"
                  type="submit"
                  disabled={submitLoading || !allowEdit}
                >
                  {submitLoading ? (
                    <LoadingWithLable
                      className={"!mt-0 text-white "}
                      text={"SUBMITTING"}
                    />
                  ) : (
                    `SUBMIT`
                  )}
                </button>
              </div>
            </form>
          </div>
        </>
      ) : (
        <LoadingWithLable />
      )}
    </div>
  );
}

const generateFeeChanges = (
  INITIAL_FEE_PAYABLE,
  FEE_PAYABLE_AFTER_ADD_EDIT_DELETE
) => {
  const desiredOutput = [];
  for (const item of FEE_PAYABLE_AFTER_ADD_EDIT_DELETE) {
    if (item.id) {
      // If an object has an id, set its type as "edit"
      desiredOutput.push({
        type: "edit",
        fees_payable_id: item.id,
        item: item.item,
        remark: item.remark,
        cost: item.cost,
      });
    } else {
      // If an object does not have an id, set its type as "add"
      desiredOutput.push({
        type: "add",
        item: item.item,
        remark: item.remark,
        cost: item.cost,
      });
    }
  }

  // Compare with INITIAL_FEE_PAYABLE and add "delete" type for missing items
  for (const initialItem of INITIAL_FEE_PAYABLE) {
    const found = desiredOutput.some(
      (item) => item.fees_payable_id === initialItem.id
    );
    if (!found) {
      desiredOutput.push({
        type: "delete",
        fees_payable_id: initialItem.id,
      });
    }
  }

  return desiredOutput;
};

const generateMuqeem = (INITIAL_MUQEEM, MUQEEM_AFTER_ADD_EDIT_DELETE) => {
  const desiredOutput = [];
  for (const item of MUQEEM_AFTER_ADD_EDIT_DELETE) {
    if (item.id) {
      // If an object has an id, set its type as "edit"
      desiredOutput.push({
        type: "edit",
        muqeem_points_id: item.id,
        particular: item.particular,
        deduction: item.deduction,
        equivalent_sar: item.equivalent_sar,
        paid_by: item.paid_by,
      });
    } else {
      // If an object does not have an id, set its type as "add"
      desiredOutput.push({
        type: "add",
        particular: item.particular,
        deduction: item.deduction,
        equivalent_sar: item.equivalent_sar,
        paid_by: item.paid_by,
      });
    }
  }

  // Compare with INITIAL_MUQEEM and add "delete" type for missing items
  for (const initialItem of INITIAL_MUQEEM) {
    const found = desiredOutput.some(
      (item) => item.muqeem_points_id === initialItem.id
    );
    if (!found) {
      desiredOutput.push({
        type: "delete",
        muqeem_points_id: initialItem.id,
      });
    }
  }
  return desiredOutput;
};

function allowFeeEdit(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return true;
  }

  for (let i = 0; i < arr1.length; i++) {
    const obj1 = arr1[i];
    const obj2 = arr2[i];

    for (const key in obj1) {
      if (obj1[key] !== obj2[key]) {
        return true;
      }
    }
  }

  return false;
}
